import React from "react";
import { Button, Col, Input, Row, Space } from "antd";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import get from "lodash/get";
import trim from "lodash/trim";
import toLower from "lodash/toLower";
const SearchPart = ({ onSearchPart, getParts, togglePartModal, parts }) => {
  return (
    <Row>
      <Col xs={24} md={24} className="flex flex-row justify-end mb-4">
        <Space>
          {get(parts, "partsArr.length") > 0 && (
            <Input
              style={{
                width: 250,
              }}
              size="middle"
              onChange={(val) => {
                onSearchPart(toLower(trim(val.target.value)));
              }}
              value={get(parts, "query")}
              placeholder="Search Parts"
              suffix={
                get(parts, "query") && (
                  <CloseOutlined
                    onClick={() => getParts()}
                    className="text-gray-400"
                  />
                )
              }
              prefix={<SearchOutlined className="mr-2 text-gray-400" />}
            />
          )}
          <Button
            type="primary"
            onClick={() => {
              togglePartModal();
            }}
          >
            Add Part
          </Button>
        </Space>
      </Col>
    </Row>
  );
};
export default SearchPart;